import { createSlice } from "@reduxjs/toolkit";

const initialCookieJarState = () => {
    return {
        // Null cookies will cause the component to display a loading
        // indicator until a valid cookie list response is received.
        cookies: null,
    };
};

const cookieJarSlice = createSlice({
    name: "cookieJar",
    initialState: initialCookieJarState(),
    reducers: {
        receive: (state, action) => {
            return {
                ...state,
                cookies: action.payload.cookies,
            };
        },
    },
});

export const { receive: receive_cookies_list } = cookieJarSlice.actions;

export default cookieJarSlice.reducer;
